/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-cycle */
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

import {
  AccordionItemComponent,
  ContactDetails,
  CtaButton,
  StepItemComponent,
} from '../../components'
import AccordionsWrapper from '../../components/AccordionsWrapper/AccordionsWrapper'
import { useContactcontent, useMediaquery } from '../../hooks'
import { useNewStepsContent } from '../../hooks/useNewStepsContent'
import { SectionContainer } from '../../layouts'
import { ContentParser } from '../../utils/helpers'
import {
  bacgroundImage,
  btnContainer,
  buttonClassName,
  contentClassname,
  extraOpenClassname,
  footerContainer,
  footerTitle,
  headingContentContainer,
  linkColor,
  sectionStyles,
  singleStep,
  stepsContentContainer,
  stepsWithBorder,
  stepsWraping,
  titleClassname,
} from './StepsSection.module.css'

const NewStepsSection = ({ component, lang, pageType, slice }) => {
  const { stepsdata } = slice

  const isDesktop = useMediaquery('(min-width: 1200px)')
  const stepsData = useNewStepsContent()

  const localizedStepsData = stepsData.filter(
    (step) => step.language.slug === lang,
  )

  const contactData = useContactcontent()
  const localizedContactData = contactData.filter(
    (contact) => contact.language.slug === lang,
  )

  const {
    contactcontent: {
      bookingcontent,
      bookinglabel,
      contactDetails,
      contactTitle,
      emailaddress,
      emaillabel,
      scheduledetails,
      scheduletitle,
    },
  } = localizedContactData[0]

  const {
    stepscontent: {
      membershipbutton,
      stepscontainerwidth,
      stepsheading,
      stepskicker,
    },
  } = localizedStepsData[0]

  const contactSteps = [
    { content: contactDetails, title: contactTitle },
    { content: emailaddress, title: emaillabel },
    { content: bookingcontent, title: bookinglabel },
  ]
  const { stepscontent } = localizedStepsData[0]
  // const { background } = stepscontent
  let processSteps = []

  const buttonLink =
    membershipbutton?.url || lang === 'nl'
      ? ' /loyalty-programma/'
      : '/en/loyalty-program/'

  if (
    ContentParser(stepsdata, 'step').filter((item) => item.steptitle !== null)
      .length
  ) {
    processSteps = ContentParser(stepsdata, 'step').filter(
      (item) => item.steptitle !== null,
    )
  } else {
    const { step1, step2, step3, step4 } = stepscontent
    processSteps = [step1, step2, step3, step4]
  }

  // const backgRoundImg = component === 'processsection' ? null : background
  const isDiv = pageType === 'contact' ? true : isDesktop

  return (
    <SectionContainer
      containerwidth={stepscontainerwidth}
      extraClassName={sectionStyles}
      extraHeadingContainerClassName={headingContentContainer}
      heading={stepsheading}
      kicker={stepskicker}
      withHeader
      // backGround={backgRoundImg}
    >
      <AccordionsWrapper
        className={`${stepsContentContainer} ${
          pageType !== 'contact' ? stepsWithBorder : ''
        } ${pageType === 'category' ? stepsWraping : ''}`}
        isDesktop={isDiv}
      >
        {pageType !== 'contact' &&
          processSteps &&
          processSteps.map((step, index) => {
            return isDesktop ? (
              <StepItemComponent
                key={`${step.title}-${index}` || index}
                component={pageType}
                extraClassName={`${pageType === 'category' ? singleStep : ''}`}
                index={index}
                step={step}
                vacanciesStep={component === 'vacanciesstepssection'}
              />
            ) : (
              <AccordionItemComponent
                key={`${step.title}-${index}` || index}
                active={index === 0}
                contentClassname={contentClassname}
                extraOpenClassname={extraOpenClassname}
                index={index}
                item={step}
                titleClassname={titleClassname}
                withIndicator
              />
            )
          })}
        {pageType === 'contact' &&
          contactSteps &&
          contactSteps.map((step, index) => {
            return (
              <StepItemComponent
                key={`${step.title}-${index}` || index}
                component={slice.fieldGroupName}
                contactStep
                index={index}
                step={step}
              />
            )
          })}
      </AccordionsWrapper>
      {stepscontent.stepsfooter && pageType !== 'category' && (
        <div className={footerContainer}>
          <div className={btnContainer}>
            {ContentParser(stepscontent.stepsfooter, 'stepscta').map(
              (cta, index) => {
                let ctaContent = cta
                if (typeof cta === 'string') {
                  ctaContent = JSON.parse(cta)
                }
                return (
                  <CtaButton
                    key={`${cta.title}-${index}`}
                    {...ctaContent}
                    lang={lang}
                    newCta={index === 1}
                    type="primary"
                  />
                )
              },
            )}
            <CtaButton
              extraClassName={buttonClassName}
              title={membershipbutton?.tilte || 'Become a member'}
              type="secondary"
              url={buttonLink}
              wide
            />
          </div>
          <ContactDetails
            extraTitleClassName={`${linkColor} ${isDesktop ? '' : footerTitle}`}
            kicker={contactTitle}
            phone
            title={contactDetails}
          />
          <ContactDetails
            extraTitleClassName={isDesktop ? '' : footerTitle}
            kicker={scheduletitle}
            renderContent={scheduledetails}
          />
        </div>
      )}
      {component === 'processsection' && !isDesktop && (
        <StaticImage
          alt="EA Kliniken"
          className={bacgroundImage}
          quality={100}
          src="../../assets/images/stepsmobile.png"
        />
      )}
    </SectionContainer>
  )
}

export default NewStepsSection
